/* --- Layout (used by orchestrator, Part 10) --- */

.checklistWrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: clip;
}

.checklistControls {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-bottom: 1px solid #e9ecef;
    padding: 0.75rem 1rem;
    gap: 0.5rem;
}

.checklistItems {
    display: flex;
    flex-direction: column;
    gap: 0;
    flex: 1;
    overflow: auto;
}

/** Legacy link styling */

/* Inline link parity (LEGACY). Unlayered to beat the unlayered
   `.navLink` rule in components/contentLink.module.css. Hardcoded blue
   per TASK_FINALIZED (not factored with #1). */
.checklistItems :global(a)[href]:not([href="#"]) {
    color: rgb(43, 102, 199);
    text-decoration: none;
}

.checklistItems :global(a)[href]:not([href="#"]):hover {
    text-decoration: underline;
}
/* Legacy link styling --- END */

.checklistDescription {
    border-bottom: 1px solid #e9ecef;
    padding: 0 1.5rem;

    > h1 {
        font-size: 1.5rem;
        line-height: 2.25rem;
        margin: 1rem 0;
    }

    ul {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
}

/* --- Tree --- */

.checklistTree {
    margin-bottom: 6rem;
}

/* --- NoContent (empty results) --- */

.noContent {
    padding: 4rem;
    text-align: center;

    h1 {
        text-align: center;
    }

    dl {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 1rem;
        margin: 0 auto;
        width: fit-content;

        dt {
            font-weight: bold;
            text-align: right;
        }

        dd {
            margin: 0;
            text-align: left;
            max-width: 15rem;
        }
    }
}

.documentPlaceholder {
    padding: 2rem;
    color: var(--mantine-color-dimmed);
}

/* --- CheckItemParent --- */

.checkItemParent {
    background: white;
    border-bottom: 1px solid #e9ecef;

    .checkItemParent {
        border-bottom: none;
    }

    > header {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem;
        cursor: pointer;
        z-index: 1;
        position: relative;

        &.isOpen {
            margin-bottom: -1rem;
        }

        &:hover {
            background-color: hsl(195, 20%, 96%);
        }

        .checkItemTitle {
            > h4 {
                flex-grow: 0;
                font-size: 1.25rem;
                line-height: 1.5rem;
                font-weight: 700;
                color: #333;
            }
        }
    }

    > .checkItemContent {
        display: flex;
        flex-direction: column;
        border-left: 1px solid #e9ecef;
        padding: 1rem 0 0 0;
        margin-left: 2rem;
        margin-bottom: 1rem;

        > .contentSections,
        > .relatedSection,
        > .filesSection {
            padding-left: 2rem;

            .contentBody {
                padding-left: 0;
            }
        }
    }

    .contentBody {
        padding-left: 2rem;
    }
}

/* --- CheckItemLeafNode --- */

.checkItemLeafNode {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 1rem 1rem 1rem 2rem;

    &:hover {
        background-color: hsl(195, 20%, 96%);
    }

    .contentBody {
        padding-left: 0;
    }

    .checkItemLeafNodeContent {
        flex: 1;
    }

    header {
        h4 {
            font-size: 1.125rem;
            line-height: 1.5rem;
            font-weight: 700;
            color: #333;
        }
    }

    .contentSections {
        margin: 0;
    }

    &.checkItemInfo {
        background: rgba(201, 209, 231, 0.17);
        margin: 1rem 1rem 1rem 2rem;
        border-radius: 0.5rem;

        &:hover {
            background: rgba(201, 209, 231, 0.17);
        }

        .contentSections {
            margin: 0 0 2rem 0;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

/* --- Shared title --- */

.checkItemTitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    gap: 0.5rem;

    > h4 {
        margin: 0;
    }
}

/* --- Content sections --- */

.contentSections {
    margin: 1rem 0;

    &:last-child {
        margin-bottom: 0;
    }
}

.contentBody {
    font-size: var(--mantine-font-size-md);
}

.ingressSection {
}

.descriptionSection {
}

.descriptionToggle {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: var(--mantine-font-size-sm);
    color: #222;
    padding: 0.25rem 0.75rem;
    margin: 0.25rem -0.75rem;
}

.descriptionToggle:disabled {
    background-color: #e0e4ed;
    opacity: 0.5;
}

.lawSection {
    font-size: var(--mantine-font-size-sm);
}

.loadingIndicator {
    padding: 1rem 1.5rem;
}

/* --- Related / files --- */

.relatedSection,
.filesSection {
    ul {
        list-style: none;
        margin: 1rem 0;
        padding: 0;

        > li {
            margin: 0.5rem 0;
        }
    }
}

/* --- CategoryOpenIcon --- */

.openIconContainer {
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 0.375rem;
    background-color: hsl(196, 35%, 92%);
    transition: background-color 0.15s ease;
}

.openIconContainerOpen {
    background-color: hsl(197, 97%, 12%);
}

.openIcon {
    width: 0.875rem;
    height: 0.875rem;
    transition: transform 0.15s ease;
    transform: rotate(90deg);
}

.openIconOpen {
    transform: rotate(180deg);
}

.openIconContainer polygon {
    fill: hsl(197, 97%, 12%);
    stroke: hsl(197, 97%, 12%);
    stroke-linejoin: round;
    stroke-width: 1;
}

.openIconContainerOpen polygon {
    fill: #fff;
    stroke: #fff;
}

/* Description toggle icon overrides — strip background, shrink */

.descriptionToggle .openIconContainer {
    width: initial;
    height: initial;
    background: none;
    border-radius: 0;
}

.descriptionToggle .openIconContainerOpen {
    background: none;
}

.descriptionToggle .openIcon {
    width: 0.75rem;
    height: 0.75rem;
}

.descriptionToggle polygon {
    fill: #222;
    stroke: #222;
}

/* --- Narrow-viewport toolbar (replaces the old drawer + hamburger) --- */

.mobileToolbar {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
    border-bottom: 1px solid var(--mantine-color-default-border);
    flex: 0 0 auto;
}

.mobileToolbarTitle {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}

.mobileToolbarTopicName {
    color: var(--mantine-color-gray-7);
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.4px;
    line-height: 1rem;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mobileToolbarFillingTitle {
    color: var(--mantine-color-gray-7);
    font-size: var(--mantine-font-size-md);
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mobileToolbarActions {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    flex: 0 0 auto;
}

/* --- Narrow-viewport global-filter Collapse panel --- */

.mobileFilterPanel {
    display: flex;
    flex-wrap: wrap;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    border-bottom: 1px solid var(--mantine-color-default-border);
}

/* --- Narrow-viewport chip row + collapsing search --- */

.mobileControls {
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
    border-bottom: 1px solid var(--mantine-color-default-border);
    flex: 0 0 auto;
}

.chipRow {
    display: flex;
    flex-wrap: nowrap;
    gap: var(--mantine-spacing-xs);
    overflow-x: auto;
    flex: 1;
    min-width: 0;
    scrollbar-width: none;
}

.chipRow::-webkit-scrollbar {
    display: none;
}

.searchToggle {
    flex: 0 0 auto;
}

.searchExpanded {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
    background: var(--mantine-color-body);
}

.searchField {
    flex: 1;
    min-width: 0;
}

/* --- Narrow-viewport sticky bottom action bar --- */

.mobileActionBar {
    flex: 0 0 auto;
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    padding-bottom: max(var(--mantine-spacing-sm), env(safe-area-inset-bottom));
    border-top: 1px solid var(--mantine-color-default-border);
    background: var(--mantine-color-body);
}

/* --- Desktop layout (>= 992px) --- */

@media (min-width: 992px) {
    .checklistWrapper {
        display: grid;
        grid-template-columns: 25rem 1fr;
        grid-template-rows: auto auto 1fr auto;
        max-width: var(--app-max-width);
        margin: 0 auto;
    }

    .checklistConfig {
        padding: 3.5rem 1rem 1rem 1rem;

        display: flex;
        flex-direction: column;
        gap: 1rem;
        grid-column: 1;
        grid-row: 1 / 3;
    }

    .checklistTocWrapper {
        overflow: auto;
        grid-column: 1;
        grid-row: 3 / 4;
    }

    .checklistGenerateButtons {
        padding: 1rem;
        grid-column: 1;
        grid-row: 4;
    }

    .checklistControls {
        flex-direction: row;
        align-items: flex-start;
        gap: 1rem;
        border-left: 1px solid #e9ecef;
        border-bottom: 1px solid #e9ecef;
        grid-column: 2;
        grid-row: 1;
        flex-wrap: nowrap;
    }

    .checklistFilters {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        flex: 1 1 0;
        min-width: 0;
    }

    .checklistSearch {
        flex: 0 0 14rem;
    }

    .checklistExpandButton {
        flex: 0 0 auto;
        white-space: nowrap;
    }

    .checklistItems {
        max-height: 100%;
        position: relative;
        grid-column: 2;
        grid-row: 2 / 5;
        border-left: 1px solid #e9ecef;

        &.documentPane {
            grid-row: 1 / 5;
        }
    }
}
